var neutral = {
  variant: 'neutral'
};
var negative = {
  variant: 'negative'
};
var caution = {
  variant: 'caution'
};
var informative = {
  variant: 'informative'
};
var bannerVariants = {
  neutral: neutral,
  negative: negative,
  caution: caution,
  informative: informative
};

export { bannerVariants };
//# sourceMappingURL=banner.variants.esm.js.map
